import {default as cx} from "classnames"
import Avatar from "react-avatar"

import {useStableNavigate} from "../utilities/StableNavigateContext"
import {capitalizePersonName} from "../utilities/general"

const NURSING_DEGREE_LABELS = {
    associate: "Associate Degree",
    bachelors: "Bachelors Degree",
    masters: "Masters Degree",
    unsure: "Unsure",
}

const degreeLabel = (value) => NURSING_DEGREE_LABELS[value] ?? value ?? "Incomplete"

const OrienteeCardSummary = ({orientee, onCompleteOnboarding}) => {
    const preceptorsIncomplete = !orientee.preceptors?.length
    const navigate = useStableNavigate()

    return (
        <div className="card card-px-0 p-4 px-md-8 mt-8 mx-8">
            <div className="card-header">
                <div className="card-title text-dark fw-bold gap-4 flex-fill">
                    <div className="d-flex flex-row flex-fill align-items-center">
                        <div className="d-none d-md-flex me-2">
                            <Avatar
                                name={orientee.name}
                                size="40"
                                round="0.475rem"
                                maxInitials={2}
                                color="var(--bs-primary)"
                                fgColor="var(--bs-primary-inverse, #fff)"
                            />
                        </div>
                        <div className="d-flex flex-column fs-5">
                            <div className="d-flex flex-row" data-testid="orientee_name">
                                {orientee.name}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-toolbar gap-4 flex-grow-1 flex-md-grow-0">
                    <button
                        type="button"
                        className="btn btn-light-primary flex-center flex-grow-1 flex-md-grow-0"
                        onClick={() => onCompleteOnboarding?.(orientee)}
                    >
                        <i className="fas fa-arrow-right fs-4 me-2"></i>
                        Complete Onboarding
                    </button>
                    <button
                        type="button"
                        className="btn btn-light-primary flex-center flex-grow-1 flex-md-grow-0"
                        onClick={() => {
                            navigate(`/educator-orientations/${orientee.orientation_id}/status?returnTo=onboarding`)
                        }}
                    >
                        Manage Orientation Status
                    </button>
                </div>
            </div>
            <div className="card-body py-3">
                <div className="row g-4">
                    <div className="col">
                        <div className="d-flex flex-wrap fw-semibold fs-6 gap-2">
                            <span className="d-flex align-items-center me-5 mb-2">
                                <i className="fas fa-hospital text-primary fs-6 me-2"></i>
                                {orientee.unit_name}
                            </span>
                            <span className="d-flex align-items-center me-5 mb-2">
                                <i className="fas fa-user-nurse text-primary fs-6 me-2"></i>
                                {orientee.position ?? "Not Set"}
                            </span>
                            <span
                                className={cx("d-flex align-items-center me-5 mb-2", {
                                    "text-danger": !orientee.experience_level_name,
                                })}
                            >
                                <i className="fas fa-clock-rotate-left text-primary fs-6 me-2"></i>
                                Prior Exp: {orientee.experience_level_name || "Incomplete"}
                            </span>
                            <span
                                className={cx("d-flex align-items-center me-5 mb-2", {
                                    "text-danger": !orientee.nursing_program,
                                })}
                            >
                                <i className="fas fa-graduation-cap text-primary fs-6 me-2"></i>
                                Nursing Program: {degreeLabel(orientee.nursing_program_completed)}
                            </span>
                            <span className="d-flex align-items-center me-5 mb-2">
                                <i className="fas fa-flag text-primary fs-6 me-2"></i>
                                Hired: {orientee.hire_date}
                            </span>
                            <span className="d-flex align-items-center me-5 mb-2">
                                <i className="fas fa-calendar-xmark text-primary fs-6 me-2"></i>
                                Expected End Date: {orientee.expected_end_date}
                            </span>
                            <span className="d-flex align-items-center me-5 mb-2">
                                <i className="fas fa-calendar-week text-primary fs-6 me-2"></i>
                                Length: {orientee.orientation_length_weeks}{" "}
                                {orientee.orientation_length_weeks ? "W" : ""}
                            </span>
                            <span
                                className={cx("d-flex align-items-center me-5 mb-2", {
                                    "text-danger": preceptorsIncomplete,
                                })}
                            >
                                <i className="fas fa-hospital-user text-primary fs-6 me-2"></i>
                                Preceptors:{" "}
                                {preceptorsIncomplete
                                    ? "Incomplete"
                                    : orientee.preceptors.map((p) => capitalizePersonName(p.name)).join(", ")}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrienteeCardSummary
